import { render, staticRenderFns } from "./EditTerminology.vue?vue&type=template&id=c6a756c0"
import script from "./EditTerminology.vue?vue&type=script&lang=js"
export * from "./EditTerminology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports